<!-- Vertical Button List -->
<div class="vertical-buttons">
  <!-- Save Devis Button -->
  <button *ngIf="!isApprovePage" class="btn vertical-btn" (click)="openImportQRModal()" aria-label="Save Devis">
    <a style="color: rgba(47, 43, 61, 0.9);">
      <i data-feather="download" [size]="20"></i>
    </a>
  </button>
  <!-- Download Devis Button -->
  <button *ngIf="!isApprovePage" class="btn vertical-btn" (click)="openSettingsPanel()" aria-label="Download Devis">
    <a style="color: rgba(47, 43, 61, 0.9);">
      <i data-feather="settings" [size]="20"></i>
    </a>
  </button>
  <!-- Share Devis Button -->
  <button class="btn vertical-btn" (click)="onDownloadPDFClick()" aria-label="Download PDF">
    <a style="color: rgba(47, 43, 61, 0.9);">
      <i data-feather="file" [size]="20"></i>
    </a>
  </button>
  <!-- Print Devis Button -->
  <button class="btn vertical-btn" (click)="openCachetModal(cachetModal)" aria-label="Print Devis">
    <a style="color: rgba(47, 43, 61, 0.9);">
      <i data-feather="disc" [size]="20"></i>
    </a>
  </button>
  <!-- File Earmark Check Button -->
  <button class="btn vertical-btn" aria-label="Print Devis">
    <a (click)="openDetailModal()">
        <i class="bi bi-paperclip"  style="color: rgba(47, 43, 61, 0.9);"></i>
    </a>
  </button>
  <!-- Mail Button -->
    <button class="btn vertical-btn" (click)="openEmailModal()" aria-label="Compose Email">
        <a style="color: rgba(47, 43, 61, 0.9);">
            <i data-feather="mail" [size]="20"></i>
        </a>
    </button>
</div>


<app-email-compose></app-email-compose>


    <!-- Settings Panel Overlay -->
  <div class="settings-overlay" [class.active]="isSettingsPanelOpen" (click)="closeSettingsPanel()"></div>

  <!-- Settings Panel -->
 <div class="settings-panel" [class.active]="isSettingsPanelOpen">
  <div class="settings-header">
    <h3>Paramètres document</h3>
    <button class="close-btn" (click)="closeSettingsPanel()" aria-label="Close Settings">
        <i class="bi bi-x-lg" ></i></button>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <button 
      class="tab" 
      [class.active]="activeTab === 'document'"
      (click)="setActiveTab('document')"
      aria-label="Document Settings">
      Document
    </button>
    <button 
      class="tab" 
      [class.active]="activeTab === 'taxe'"
      (click)="setActiveTab('taxe')"
      aria-label="Tax Settings">
      Taxe
    </button>
    <button 
      class="tab" 
      [class.active]="activeTab === 'devise'"
      (click)="setActiveTab('devise')"
      aria-label="Currency Settings">
      Devise
    </button>
  </div>

  <!-- Tab Content -->
  <div class="tab-content">
    <!-- Document Tab -->
    <div *ngIf="activeTab === 'document'">
      <div class="form-group">
        <label>Label</label>
        <input type="text"   [(ngModel)]="documentType" class="form-control" aria-label="Document Label">
      </div>

      <div class="form-group">
        <label>Date d'échéance</label>
        <div class="date-frequency">
          <div class="frequency-options">
            <label class="container">
              <input type="radio" 
                     class="tva-radio"
                     name="frequency" 
                     value="jours" 
                     [(ngModel)]="dateFrequency"
                     (ngModelChange)="onDateFrequencyChange()"
                     aria-label="Days">
              <span class="checkmark"></span>
              <span class="droite">Jours</span>
            </label>
            <label class="container">
              <input type="radio" 
                     class="tva-radio"
                     name="frequency" 
                     value="mois" 
                     [(ngModel)]="dateFrequency"
                     (ngModelChange)="onDateFrequencyChange()"
                     aria-label="Months">
              <span class="checkmark"></span>
              <span class="droite">Mois</span>
            </label>
            <label class="container">
              <input type="radio" 
                     class="tva-radio"
                     name="frequency" 
                     value="annee" 
                     [(ngModel)]="dateFrequency"
                     (ngModelChange)="onDateFrequencyChange()"
                     aria-label="Years">
              <span class="checkmark"></span>
              <span class="droite" style="padding-right: 5px">Année</span>
            </label>
            <div class="d-flex align-items-center">
                <button type="button" class="del-button del1-button" (click)="decrementPaymentPeriod()">-</button>
                <input
                  type="number"
                  class="form-control"
                   [(ngModel)]="dateValue"
                  name="paymentPeriodValue"
                  style="width: 90px; margin: 0 0; text-align: center;border-radius: 0px;"
                  min="1"
                  (ngModelChange)="validateStep4()"
                />
                <button type="button" class="del-button add1-button" (click)="incrementPaymentPeriod()">+</button>
              </div>
          </div>
               
        </div>
      </div>

      <div class="form-group">
        <label>Afficher les champs du tableau</label>
        <div class="checkbox-group">
            <label class="container">
                <input type="checkbox"
                       [(ngModel)]="documentSettings.reference"
                       (ngModelChange)="onDocumentSettingChange()">
                <span class="checkmark"></span>
                <span>Référence</span>
            </label>

            <label class="container">
                <input type="checkbox"
                       [(ngModel)]="documentSettings.quantite"
                       (ngModelChange)="onDocumentSettingChange()">
                <span class="checkmark"></span>
                <span>Quantité</span>
            </label>

            <label class="container">
                <input type="checkbox"
                       [(ngModel)]="documentSettings.unite"
                       (ngModelChange)="onDocumentSettingChange()">
                <span class="checkmark"></span>
                <span>Unité</span>
            </label>

            <label class="container">
                <input type="checkbox"
                       [(ngModel)]="documentSettings.prixUnitaire"
                       (ngModelChange)="onDocumentSettingChange()">
                <span class="checkmark"></span>
                <span>Prix unitaire</span>
            </label>

            <label class="container">
                <input type="checkbox"
                       [(ngModel)]="documentSettings.tva"
                       (ngModelChange)="onDocumentSettingChange()">
                <span class="checkmark"></span>
                <span>TVA</span>
            </label>

            <label class="container">
                <input type="checkbox"
                       [(ngModel)]="documentSettings.remise"
                       (ngModelChange)="onDocumentSettingChange()">
                <span class="checkmark"></span>
                <span>Remise</span>
            </label>
        </div>
      </div>

      <div class="form-group">
        <label>Paramètres du tableau</label>
        <label class="container">
          <input type="checkbox" [(ngModel)]="documentSettings.afficherMontantsTTC"
                 (ngModelChange)="onDocumentSettingChange()">
          <span class="checkmark"></span>
          <span>Afficher les montants en TTC</span>
        </label>
      </div>

      <div class="form-group">
        <label>Afficher le code à barres</label>
        <label class="container">
          <input type="checkbox" [(ngModel)]="documentSettings.afficherCodeBarres"
                 (ngModelChange)="onDocumentSettingChange()"
                 aria-label="Show Barcode">
          <span class="checkmark"></span>
          <span>Afficher le code à barres sur les documents</span>
        </label>
      </div>

      <div class="form-group">
        <label>Document</label>
        <div class="checkbox-group-doc">
          <label class="container">
            <input type="checkbox" [(ngModel)]="documentSettings.afficherDateEcheance"
                   (ngModelChange)="onDocumentSettingChange()"
                   aria-label="Show Due Date">
            <span class="checkmark"></span>
            <span>Afficher la date d'échéance</span>
          </label>
          <label class="container">
            <input type="checkbox" [(ngModel)]="documentSettings.afficherDateLivraison"
                   (ngModelChange)="onDocumentSettingChange()"
                   aria-label="Show Delivery Date">
            <span class="checkmark"></span>
            <span>Afficher la date de livraison</span>
          </label>
          <label class="container">
            <input type="checkbox" [(ngModel)]="documentSettings.afficherMontantTotal"
                   (ngModelChange)="onDocumentSettingChange()"
                   aria-label="Show Total Amount">
            <span class="checkmark"></span>
            <span>Afficher le montant total</span>
          </label>
          <label class="container">
            <input type="checkbox" [(ngModel)]="documentSettings.afficherCoordonneesClients"
                   (ngModelChange)="onDocumentSettingChange()"
                   aria-label="Show Client Coordinates">
            <span class="checkmark"></span>
            <span>Afficher les coordonnées des clients</span>
          </label>
        </div>
      </div>

        <div class="form-group">
            <label>Couleur primaire</label>
            <input type="color" [(ngModel)]="primaryColor" (ngModelChange)="onColorChange()" class="color-input" aria-label="Primary Color">
        </div>

      <button class="btn save-btn text-white mr-1 ml-50 my-1 align-items-center justify-content-between" (click)="saveSettings()" aria-label="Save Settings" style="width: auto;height: auto;background: #134AD3">
        <span style="font-size: 15px;font-weight: 500;">Enregistrer Par Défaut</span></button>
    </div>
    <!-- Taxe Tab -->
      <div *ngIf="activeTab === 'taxe'">
          <div *ngIf="isLoadingTaxes" class="text-muted" style="font-size: 12px;">
              Chargement des taxes...
          </div>
          <div *ngIf="!isLoadingTaxes && taxes.length === 0" class="text-muted" style="font-size: 12px;">
              Aucune taxe disponible.
          </div>
          <div class="toggle-group">
              <div class="toggle-item" *ngFor="let tax of taxes; let i = index">
                  <div class="toggle-info">
                      <div class="toggle-details">
                          <span class="amount">{{ tax.valeur_fixe ? (tax.valeur | number:'1.3-3') + ' TND' : tax.valeur + '%' }}</span>
                          <strong style="margin-top: 20px;">{{ tax.label }}</strong>
                          <p>{{ tax.applique_apres_tva ? 'Taxe appliquée après la TVA' : 'Taxe appliquée avant la TVA' }}</p>
                      </div>
                  </div>
                  <div class="custom-control custom-control-primary custom-switch">
                      <input type="checkbox"
                             class="custom-control-input"
                             [id]="'switch' + i"
                             [checked]="getEffectiveTaxStatut(tax)"
                             aria-label="Enable {{tax.label}}"
                             (change)="onTaxToggle($event, tax)">
                      <label class="custom-control-label" [for]="'switch' + i"></label>
                  </div>
              </div>
          </div>
      </div>


    <!-- Devise Tab -->
    <div *ngIf="activeTab === 'devise'">
<div class="card-body">
    <div class="input-group input-group-merge">
      <span class="input-group-text" id="basic-addon-search2"><i data-feather="search" [size]="20"></i></span>
      <input
        type="text"
        class="form-control"
        placeholder="Search..."
        aria-label="Search..."
        aria-describedby="basic-addon-search2"
        [(ngModel)]="searchQuery"
        (ngModelChange)="filterCurrencies()"
      />
    </div>
  </div>

  <div class="currency-list two-rows">
    <div *ngFor="let currency of filteredCurrencies" class="currency-item">
      <div class="currency-flag">{{currency.flag}}</div>
      <div class="currency-info">
        <div class="currency-code">{{currency.code}}</div>
        <div class="currency-name">{{currency.name}}</div>
      </div>
      <div class="currency-amount">1.000 TND</div>
      <div class="currency-equals">=</div>
      <div class="currency-rate">{{currency.rate}}</div>
      <button class="currency-edit" (click)="editCurrency(currency)" aria-label="Edit Currency">
        <a href="javascript:void(0)" style="color: rgba(47, 43, 61, 0.7);" >
          <span data-feather="edit" [size]="20"></span>
        </a>
      </button>
    </div>
    <div *ngIf="filteredCurrencies.length === 0" class="no-results">No currencies found</div>
  </div>
</div>
  </div>
</div>





<!-- Cachet Modal -->
<ng-template #cachetModal let-modal>
  <div class="modal-header" style="background-color: transparent;">

    <button type="button" class="close" (click)="modal.dismiss('Close click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
        <h4 class="title-modal">Cachet Configuration !</h4>
    <p class="currency-amount text-center mb-2">Veuillez ajouter un cachet à partir des paramètres de votre compte</p>
      <div class="d-flex align-items-center justify-content-center" style="gap: 20px;">
          <button type="button" class="btn btn-primary" (click)="goToDocumentSettings(modal)" style="padding: 10px 20px;">
              Paramètres du document
          </button>
          <button type="button" class="btn" (click)="modal.dismiss('Close click')" style="padding: 10px 20px;background: rgba(128, 131, 144, 0.16)">
              Annuler
          </button>

      </div>
  </div>




</ng-template>


<app-email-compose #emailMoldal [documentId]="documentId"></app-email-compose>
<app-file-upload-modal #uploadModal></app-file-upload-modal>
<app-import-qr #importQR></app-import-qr>




